import React from 'react';
import styled from 'styled-components';

import { type SearchMetadata } from '@column/api';

const MatchedText = styled.span`
  color: ${({ theme }) => theme.primary.background};
  font-weight: bold;
`;

export const renderHighlight = (text: string) => {
  const parts = text.split(/(<em>.*?<\/em>)/g);
  return (
    <span>
      {parts.map((part, i) => {
        const match = part.match(/^<em>(.*?)<\/em>$/);
        if (match) {
          return <MatchedText key={i}>{match[1]}</MatchedText>;
        }
        return part;
      })}
    </span>
  );
};

export const getHighlightedField = (
  searchMetadata: SearchMetadata | undefined | null,
  ...fields: string[]
): string | undefined => {
  if (!searchMetadata?.highlights) return undefined;
  for (const field of fields) {
    const fragments = searchMetadata.highlights[field];
    if (fragments?.length) return fragments[0];
  }
  return undefined;
};
